export default "__VITE_ASSET__BJF080Ni__"